import { useEffect } from 'react';
import { useNavigate } from 'react-router-dom';

export default function OwnerLogout() {
  const navigate = useNavigate();

  useEffect(() => {
    // 1. Tarayıcı hafızasındaki tüm kullanıcı bilgilerini temizle
    localStorage.removeItem('authToken');
    localStorage.removeItem('ownerPrimaryCode');
    // Varsa diğer kullanıcıyla ilgili verileri de buradan silebilirsiniz.
    
    // 2. Kullanıcıyı ana sayfaya veya giriş sayfasına yönlendir
    // "replace: true" tarayıcı geçmişinde çıkış sayfasının kalmasını engeller,
    // böylece kullanıcı geri tuşuna bastığında tekrar çıkış yapmaya çalışmaz.
    navigate('/', { replace: true });
    
    // Not: Bazı durumlarda state'in tamamen sıfırlanması için
    // window.location.href = '/';
    // kullanımı da tercih edilebilir, ancak navigate genellikle yeterlidir.

  }, [navigate]); // useEffect'in sadece bir kez çalışmasını sağlar

  // Çıkış işlemi anlık olduğu için kullanıcıya bir şey göstermeye gerek yok.
  // Bir "Çıkış yapılıyor..." mesajı gösterilebilir.
  return <p>Çıkış yapılıyor...</p>;
}